import { ReactElement } from 'react'
import { LoadingButton } from '@mui/lab'
import { Alert, Button, Stack } from '@mui/material'
import { usePlanPdfViewer } from '../../PlanPdfViewerContext'
import { PLAN_VIEW_PLAN_PDF_CHANGED_MESSAGE } from '../../constants'
import useSavePlanPdf from '../../hooks/useSavePlanPdf'

interface Props {
  plan: Plan
}

/** Shown in the selected plan's panel while its PDF has unsaved changes from the preview. */
const PlanPdfChangedNotice = ({ plan }: Props): ReactElement | null => {
  const { viewer, changedDocument, setChangedDocument, setLoadedDocument } = usePlanPdfViewer()
  const { savePlanPdf, isSaving } = useSavePlanPdf()

  if (changedDocument?.guid !== plan.guid) return null

  const discard = () => {
    // Unpinning the loaded document makes the preview load the plan's current url; only when that
    // is the very url the changes were made on does the viewer have to reload it explicitly.
    if (plan.url === changedDocument.url) viewer?.reloadDocument()
    else setLoadedDocument(null)
    setChangedDocument(null)
  }

  return (
    <Stack spacing={1} data-cy="plan-view-plan-pdf-changed">
      <Alert severity="info">{PLAN_VIEW_PLAN_PDF_CHANGED_MESSAGE}</Alert>
      <Stack direction="row" spacing={1} justifyContent="flex-end">
        <Button size="small" variant="outlined" disabled={isSaving} onClick={discard}>
          Verwerfen
        </Button>
        <LoadingButton
          size="small"
          variant="contained"
          loading={isSaving}
          onClick={() => savePlanPdf(plan)}
        >
          Speichern
        </LoadingButton>
      </Stack>
    </Stack>
  )
}

export default PlanPdfChangedNotice
